/* Lone Star Cosplay - dark-override.js v4
   Stabilizes the "Selling fast! N people have this in their carts" badge counter.
   - Two tiers: HIGH (18-28) for hero products & all full armors, LOW (3-15) for everything else.
   - HIGH tier: shows "BEST SELLER" special badge.
   - LOW tier: hides the "BEST SELLER" special badge but keeps the "Selling fast" line.
   - Each product gets its own random number that persists across page loads/sessions via localStorage.
   - Affects both the product page badge and the Quick View modal badge.

   v4: Fix handle detection on product page. The product page handle is taken from
   location.pathname (the URL you are currently on), NOT from the first <a href="/products/...">
   on the page, because there are dozens of such links (related products, recently viewed, etc.).
   For Quick View, the handle is read from the modal's trigger / inner link, scoped to that modal.
*/
(function () {
  'use strict';

  var STORAGE_KEY_PREFIX = 'lsc_selling_fast_v3_';

  var HIGH_TIER_HANDLES = {
    'pyramid-head-helmet-silent-hill-custom-cosplay-prop-1-1-cosplay-item-copy': true,
    'scarborough-bayonetta-1-1-cosplay-item': true,
    'staff-of-ice': true,
    'staff-of-ice-lightning-wind-fire-call-of-duty-black-ops-ii-1-1-cosplay-item': true,
    'sly-coopers-cane-1-1-cosplay-item': true,
    'vorpal-blade-alice-madness-returns-1-1-cosplay-item-ships-in-3-days': true,
    'guts-sword-1-1-cosplay-item': true,
    'guts-sword-elden-ring-1-1-cosplay-item': true,
    'wearable-doom-slayer-armor-1-1-cosplay-item': true,
    'wearable-halo-masterchief-armor-1-1-cosplay-item': true,
    'wearable-halo-reach-spartan-armor-with-accessories-1-1-cosplay-item': true,
    'wearable-halo-masterchief-armor-1-1-cosplay-item-copy': true,
    'wearable-halo-noble-6-armor-with-accessories-1-1-cosplay-item': true
  };

  var HIGH_MIN = 18;
  var HIGH_MAX = 28;
  var LOW_MIN  = 3;
  var LOW_MAX  = 15;

  // Get handle from the URL we're currently on. This is the source of truth for the product page.
  function getHandleFromUrl() {
    var path = location.pathname || '';
    var pm = path.match(/\/products\/([a-z0-9-]+)/i);
    return pm ? pm[1].toLowerCase() : '';
  }

  function getProductId(scopeEl) {
    var formMatch = scopeEl.querySelector && scopeEl.querySelector('[form^="product-form-"]');
    if (formMatch) {
      var formId = formMatch.getAttribute('form') || '';
      var idMatch = formId.match(/(\d+)$/);
      if (idMatch) return idMatch[1];
    }
    if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product) {
      return String(window.ShopifyAnalytics.meta.product.id);
    }
    var bodyId = document.body.getAttribute('data-product-id');
    if (bodyId) return bodyId;
    var path = location.pathname;
    var hash = 0;
    for (var i = 0; i < path.length; i++) {
      hash = ((hash << 5) - hash + path.charCodeAt(i)) | 0;
    }
    return 'path_' + Math.abs(hash);
  }

  // Find the most likely product handle for a given scope (badge container or its ancestor).
  // If we're on the main product page (scopeEl === document or descendant of <main-product> section),
  // use the URL. If we're inside a Quick View modal, look for a product link/form within that modal.
  function getProductHandleForScope(scopeEl, badgeEl) {
    // Determine if this badge is inside a Quick View modal.
    var modalAncestor = null;
    if (badgeEl && badgeEl.closest) {
      modalAncestor = badgeEl.closest('hdt-lazy-modal, .hdt-quickview, [class*="quickview" i], [class*="quick-view" i]');
    }

    if (modalAncestor) {
      // Inside Quick View - read handle from the modal's content.
      // Try product form first (most reliable)
      var formEl = modalAncestor.querySelector && modalAncestor.querySelector('form[action*="/cart/add"]');
      if (formEl) {
        var inputHandle = formEl.querySelector('input[name="product-handle"], input[name="handle"]');
        if (inputHandle && inputHandle.value) return inputHandle.value.toLowerCase();
      }
      // Look for product link inside the modal
      var linkEl = modalAncestor.querySelector && modalAncestor.querySelector('a[href*="/products/"]');
      if (linkEl) {
        var href = linkEl.getAttribute('href') || '';
        var m = href.match(/\/products\/([a-z0-9-]+)/i);
        if (m) return m[1].toLowerCase();
      }
      return ''; // Quick View without a discoverable handle - skip tier logic
    }

    // Not in a modal - we're on the main product page, use the URL.
    return getHandleFromUrl();
  }

  function isHighTier(handle) {
    if (!handle) return false;
    return HIGH_TIER_HANDLES[handle.toLowerCase()] === true;
  }

  function getRange(handle) {
    if (isHighTier(handle)) {
      return { min: HIGH_MIN, max: HIGH_MAX, tier: 'high' };
    }
    return { min: LOW_MIN, max: LOW_MAX, tier: 'low' };
  }

  function getStableNumber(productId, range) {
    var key = STORAGE_KEY_PREFIX + range.tier + '_' + productId;
    try {
      var stored = localStorage.getItem(key);
      if (stored !== null) {
        var n = parseInt(stored, 10);
        if (!isNaN(n) && n >= range.min && n <= range.max) return n;
      }
      var diff = range.max - range.min;
      var rand = Math.floor(Math.random() * (diff + 1)) + range.min;
      localStorage.setItem(key, String(rand));
      return rand;
    } catch (e) {
      var diff2 = range.max - range.min;
      return Math.floor(Math.random() * (diff2 + 1)) + range.min;
    }
  }

  // Hide BEST SELLER badge for low-tier products. Scoped to a specific badges container
  // so we don't accidentally hide BEST SELLER on a high-tier Quick View while on a low-tier page.
  function hideBestSellerBadgeIn(container) {
    if (!container || !container.querySelectorAll) return;
    var badges = container.querySelectorAll('hdt-badge');
    badges.forEach(function (b) {
      if (b.dataset.lscBestsellerProcessed) return;
      var txt = (b.textContent || '').trim();
      if (/^best\s*seller$/i.test(txt)) {
        b.style.display = 'none';
        b.dataset.lscBestsellerProcessed = '1';
      }
    });
  }

  // Process one badges block at a time so the handle/tier check is correct for that block.
  function processBadgesBlock(badgesBlockEl) {
    if (!badgesBlockEl) return;
    if (badgesBlockEl.dataset.lscBlockProcessed) return;

    var handle = getProductHandleForScope(document, badgesBlockEl);
    var range = getRange(handle);
    var productId = getProductId(document);
    var stableNumber = getStableNumber(productId, range);

    // Stabilize "Selling fast! N people..." text
    var statusEls = badgesBlockEl.querySelectorAll('.hdt-product__status-content p');
    statusEls.forEach(function (p) {
      if (p.dataset.lscStabilized) return;
      var originalText = p.textContent || '';
      var newText = originalText.replace(/\d+/, String(stableNumber));
      if (newText !== originalText) {
        p.textContent = newText;
      }
      p.dataset.lscStabilized = '1';
    });

    // Stabilize <number-random> elements
    var randomEls = badgesBlockEl.querySelectorAll('number-random');
    randomEls.forEach(function (el) {
      if (el.dataset.lscStabilized) return;
      el.textContent = String(stableNumber);
      el.dataset.lscStabilized = '1';
      el.removeAttribute('config');
    });

    // Hide BEST SELLER for low tier
    if (range.tier === 'low') {
      hideBestSellerBadgeIn(badgesBlockEl);
    }

    badgesBlockEl.dataset.lscBlockProcessed = '1';
  }

  function processAll() {
    // Find every badges block on the page (product page + any Quick View modal that's open)
    var blocks = document.querySelectorAll('.hdt-product__badges');
    blocks.forEach(processBadgesBlock);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', processAll);
  } else {
    processAll();
  }

  var observer = new MutationObserver(function (mutations) {
    var needsRerun = false;
    for (var i = 0; i < mutations.length; i++) {
      var m = mutations[i];
      if (m.type === 'childList' && m.addedNodes.length) {
        for (var j = 0; j < m.addedNodes.length; j++) {
          var node = m.addedNodes[j];
          if (node.nodeType !== 1) continue;
          if (node.matches && (
              node.matches('.hdt-product__badges') ||
              (node.querySelector && node.querySelector('.hdt-product__badges'))
          )) {
            needsRerun = true;
            break;
          }
        }
      }
      if (needsRerun) break;
    }
    if (needsRerun) {
      setTimeout(processAll, 50);
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

  var ticks = 0;
  var interval = setInterval(function () {
    processAll();
    ticks++;
    if (ticks >= 10) clearInterval(interval);
  }, 500);
})();
